// import React from 'react';
import { connect } from 'react-redux';
import { Action, add, clear, remove, update } from 'redux/modules/shopify';
import { IRootState } from 'redux/root_reducer';

import Accessories, { StateProps } from 'components/pages/accessories/Accessories';
import CartItem from 'types/shopify/CartItem';

const mapStateToProps = (state: IRootState): StateProps => {
    return state.shopify.hasLoaded
        ? { isLoading: false, products: state.shopify.products, accessoriesMenuDictionary: state.shopify.accessoriesMenuDictionary }
        : { isLoading: true, products: [], accessoriesMenuDictionary: null };
};

export default connect(mapStateToProps)(Accessories);



// WEBPACK FOOTER //
// ./src/containers/pages/accessories/Accessories.tsx